define(function(require) {
    // GEO09E34_GDUNO_ORG_IMM_STATUT layer definition config
    return {
        LAYER_ID : "GEO09E34_GDUNO_ORG_IMM_STATUT",
        LAYER_TYPE : "POINT",
        LOADING_MODE : "ESRI",
        INDEX : 8,
        QUERY_FIELDS : [
            "COMBINE_NUO_NUI", "CD_CS", "CD_ORGNS", "NOM_OFFCL_ORGNS", "CD_IMM", "NOM_IMM", "ORDRE_ENS", "ADRS_GEO_L1_GDUNO_IMM", "CD_POSTL_GDUNO_IMM", "SITE_WEB_ORGNS", "NOM_MUNCP",
            "NOM_MRC", "NOM_REG_ADM", "NOM_CEP", "STYLE_CART"
        ],
        FIELDS : [
            {ID : "COMBINE_NUO_NUI", NAME : "Id", DATA_TYPE : "STRING"},
            {ID : "CD_CS", NAME : "Code de l'organisme responsable", DATA_TYPE : "STRING"},
            {ID : "CD_ORGNS", NAME : "Code de l'école", DATA_TYPE : "STRING"},
            {ID : "NOM_OFFCL_ORGNS", NAME : "Nom de l'école", DATA_TYPE : "STRING"},
            {ID : "CD_IMM", NAME : "Code de l'immeuble", DATA_TYPE : "STRING"},
            {ID : "NOM_IMM", NAME : "Nom de l'immeuble", DATA_TYPE : "STRING"},
            {ID : "ORDRE_ENS", NAME : "Ordre d'enseignement", DATA_TYPE : "STRING"},
            {ID : "ADRS_GEO_L1_GDUNO_IMM", NAME : "Adresse", DATA_TYPE : "STRING"},
            {ID : "CD_POSTL_GDUNO_IMM", NAME : "Code postal", DATA_TYPE : "STRING"},
            {ID : "SITE_WEB_ORGNS", NAME : "Site web", DATA_TYPE : "STRING"},
            {ID : "NOM_MUNCP", NAME : "Municipalité", DATA_TYPE : "STRING"},
            {ID : "NOM_MRC", NAME : "MRC", DATA_TYPE : "STRING"},
            {ID : "NOM_REG_ADM", NAME : "Région administrative", DATA_TYPE : "STRING"},
            {ID : "NOM_CEP", NAME : "Circonscription électorale", DATA_TYPE : "STRING"},
            {ID : "STYLE_CART", NAME : "Style cartovista", DATA_TYPE : "STRING"},
        ],
        STYLES : [
            {
                ID : "1_OrgImm_Statut_prescolaire",
                NAME : "École préscolaire à statut particulier",
                VALUE : "1_OrgImm_Statut_prescolaire",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "ImagePointSymbolizer",
                        SRC : require("images/icones/public/public_presco_statut.png"),
                        SRC_ROLLOVER : require("images/icones/public/public_presco_statut_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(209,24,24,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 9,
                    VISIBLE : true
                }
            }, {
                ID : "2_OrgImm_Statut_primaire",
                NAME : "École primaire à statut particulier",
                VALUE : "2_OrgImm_Statut_primaire",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "ImagePointSymbolizer",
                        SRC : require("images/icones/public/public_prim_statut.png"),
                        SRC_ROLLOVER : require("images/icones/public/public_prim_statut_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(241,90,36,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 9,
                    VISIBLE : true
                }
            }, {
                ID : "3_OrgImm_Statut_secondaire",
                NAME : "École secondaire à statut particulier",
                VALUE : "3_OrgImm_Statut_secondaire",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "ImagePointSymbolizer",
                        SRC : require("images/icones/public/public_sec_statut.png"),
                        SRC_ROLLOVER : require("images/icones/public/public_sec_statut_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(251,176,59,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 9,
                    VISIBLE : true
                }
            }, {
                ID : "4_OrgImm_Statut_presc_prim",
                NAME : "École préscolaire et primaire à statut particulier",
                VALUE : "4_OrgImm_Statut_presc_prim",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "ImagePointSymbolizer",
                        SRC : require("images/icones/public/public_presco_prim_statut.png"),
                        SRC_ROLLOVER : require("images/icones/public/public_presco_prim_statut_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(140,198,63,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 9,
                    VISIBLE : true
                }
            }, {
                ID : "5_OrgImm_Statut_presc_prim_sec",
                NAME : "École préscolaire, primaire et secondaire à statut particulier",
                VALUE : "5_OrgImm_Statut_presc_prim_sec",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "ImagePointSymbolizer",
                        SRC : require("images/icones/public/public_presco_prim_sec_statut.png"),
                        SRC_ROLLOVER : require("images/icones/public/public_presco_prim_sec_statut_hover.png")
            }
        ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(0,146,69,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 9,
                    VISIBLE : true
                }
            }, {
                ID : "6_OrgImm_Statut_presc_sec",
                NAME : "École préscolaire et secondaire à statut particulier",
                VALUE : "6_OrgImm_Statut_presc_sec",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "ImagePointSymbolizer",
                        SRC : require("images/icones/public/public_presco_sec_statut.png"),
                        SRC_ROLLOVER : require("images/icones/public/public_presco_sec_statut_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(0,169,157,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 9,
                    VISIBLE : true
                }
            }, {
                ID : "7_OrgImm_Statut_prim_sec",
                NAME : "École primaire et secondaire à statut particulier",
                VALUE : "7_OrgImm_Statut_prim_sec",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "ImagePointSymbolizer",
                        SRC : require("images/icones/public/public_prim_sec_statut.png"),
                        SRC_ROLLOVER : require("images/icones/public/public_prim_sec_statut_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(0,113,188,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 9,
                    VISIBLE : true
                }
            }, {
                ID : "8_OrgImm_Statut_Fp",
                NAME : "Centre de formation professionnelle à statut particulier",
                VALUE : "8_OrgImm_Statut_Fp",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "ImagePointSymbolizer",
                        SRC : require("images/icones/public/public_form_prof_statut.png"),
                        SRC_ROLLOVER : require("images/icones/public/public_form_prof_statut_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(102,45,145,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 9,
                    VISIBLE : true
                }
            }, {
                ID : "9_OrgImm_Statut_Adu",
                NAME : "Centre d'éducation aux adultes à statut particulier",
                VALUE : "9_OrgImm_Statut_Adu",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "ImagePointSymbolizer",
                        SRC : require("images/icones/public/public_adulte_statut.png"),
                        SRC_ROLLOVER : require("images/icones/public/public_adulte_statut_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(183,0,127,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 9,
                    VISIBLE : true
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "École publique à statut particulier",
            FEATURE_ID_DATACOLUMN : "COMBINE_NUO_NUI",
            FEATURE_NAME_DATACOLUMN : "NOM_OFFCL_ORGNS",
            DATATIP_DATACOLUMNS : ["NOM_OFFCL_ORGNS", "NOM_IMM", "ORDRE_ENS", "ADRS_GEO_L1_GDUNO_IMM", "CD_POSTL_GDUNO_IMM", "NOM_MUNCP"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["NOM_OFFCL_ORGNS", "NOM_IMM", "ORDRE_ENS", "SITE_WEB_ORGNS", "ADRS_GEO_L1_GDUNO_IMM", "CD_POSTL_GDUNO_IMM", "NOM_MUNCP"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["NOM_OFFCL_ORGNS", "NOM_IMM", "ORDRE_ENS", "SITE_WEB_ORGNS", "ADRS_GEO_L1_GDUNO_IMM", "CD_POSTL_GDUNO_IMM", "NOM_MUNCP"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            SEARCHABLE_DATACOLUMNS : ["NOM_OFFCL_ORGNS", "NOM_IMM"],
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            STYLE_DATACOLUMN : "STYLE_CART",
            LABEL_DATACOLUMN : "NOM_OFFCL_ORGNS",
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : true,
                LEADER_LINES : false,
                POSITION : "MIDDLE-RIGHT",
                PRIORITY : 10,
                IS_ZOOM_LAYERED: true,
                MAX_SCALE: 30000,
            },
            VISIBLE : false,
            ZOOM_ON_FEATURE_SCALE : 6000,
        }
    };
});
